import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

const OPEN_PATH = '/web/superfunnel-weekly-report/open';

// Records a press of the SuperFunnel weekly report email's "Open your Revenue Overview" button. Public:
// the signed token is the only credential. Resolves false when this send's click was already recorded.
export const postWeeklyReportOpen = async (token: string): Promise<boolean> => {
  const response = await api.executePostRequest<ObjectResponse<{ recorded: boolean }>>(OPEN_PATH, { token });

  return response.data.data.recorded;
};
